import type { Severity } from '@prerender/diagnostics-api';

import { severityLabel } from './severityLabels';

type SeverityTagProps = {
  severity: Severity;
  muted?: boolean;
  label?: string;
};

export const severityToneClass = (tone: Severity | 'muted'): string => `diagnostics-severity-${tone}`;

function SeverityTag({ severity, muted = false, label = severityLabel(severity) }: SeverityTagProps) {
  const tone = muted ? 'muted' : severity;
  return <span className={`diagnostics-severity ${severityToneClass(tone)}`}>{label}</span>;
}

export default SeverityTag;
